export default __webpack_public_path__ + "static/media/rabbitmq-tool.877be1e4.jpg";